import { render } from "./FromWebsite.vue?vue&type=template&id=509ce9de"
import script from "./FromWebsite.vue?vue&type=script&lang=js"
export * from "./FromWebsite.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__